/* eslint-disable */
import BASE from '../../../../vue.config.js'
import listado from '../../../assets/js/ScriptListadoGeneral.js'

const $ = require('jquery')
window.$ = $

export default {
  data: () => ({
    roles: [],
    pagina:'roles',
    estatus:1,
    EstatusRegistro:'',
    idRol:0,
    del: false,
    permisoGuardar:0,
    permisoActivaInactivar:0,
    permisoEliminar:0,
    permisoConsultar:0
  }),
  methods: {
 
    ObtenerListaRoles(status){
      this.roles = [];
      fetch(`${BASE.baseUrl}api/ListadoRoles/${status}`, {
        method: 'GET',
        headers: {
                  'Authorization': sessionStorage.getItem('token'),
                  'pagina':'roles',
                  'paginaOrigen':'listadoRoles'
                }
      })
      .then(rs => rs.json())
      .catch(error => console.log('error:', error))
      .then(rs => {
        if(rs.status == 200){
          rs.result.roles.forEach((itemrol, indexrol) => {
            this.roles.push(itemrol);
          });
          rs.result.permisos.forEach((item, indx) => {
                if (item.id == 1){ this.permisoGuardar = 1;}
                if (item.id == 3){ this.permisoActivaInactivar = 1;}
                if (item.id == 4){ this.permisoEliminar = 1;}
                if (item.id == 5){ this.permisoConsultar = 1;}
          });
        }
      });
    },
    ComboEstatus(){
      this.EstatusRegistro = [
            { text: 'Activo', value: 1, isSelected: false  },
            { text: 'Inactivo', value: 0, isSelected: false  },
            { text: 'Todos', value: 2, isSelected: false  }
        ]
    }, 
    CambiarStatus(id){
        listado.methods.CambiarStatus(id,this.pagina);
    },
    EliminarRegistro(){
        listado.methods.EliminarRegistro(this.idRol,this.pagina);
        this.del = false;
    }, 
    ConsultarRol: function(event){
        this.roles = [];
        this.ObtenerListaRoles(this.estatus);
    },
   },
  mounted(){
    this.ObtenerListaRoles(1);
    this.ComboEstatus();
  }
}
